function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icon-rounded-cover-page-hollow");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.2
}, /*#__PURE__*/React.createElement("path", {
  d: "M23,.5A4.50508,4.50508,0,0,1,27.5,5V23A4.50508,4.50508,0,0,1,23,27.5H5A4.50508,4.50508,0,0,1,.5,23V5A4.50508,4.50508,0,0,1,5,.5H23M23,0H5A5,5,0,0,0,0,5V23a5,5,0,0,0,5,5H23a5,5,0,0,0,5-5V5a5,5,0,0,0-5-5Z",
  fill: "#333"
}));

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 7,
  y: 9.00006,
  width: 14,
  height: 10,
  rx: 2,
  strokeWidth: 1.25,
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none"
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  x1: 11,
  y1: 13.00006,
  x2: 17,
  y2: 13.00006,
  fill: "none",
  opacity: 0.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.75,
  stroke: "#333"
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  x1: 11,
  y1: 15.00006,
  x2: 17,
  y2: 15.00006,
  fill: "none",
  opacity: 0.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.75,
  stroke: "#333"
});

const SvgRoundedCover = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f8487254-13e0-4e35-9a38-8d8d32cd3bab",
    "data-name": "Layer 1",
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRoundedCover, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/rounded-cover.4eee149b.svg";
export { ForwardRef as ReactComponent };